import { supabase } from './supabase';
import { addContactImageCore, deleteContactImageCore, listContactImagesCore, setDefaultProfileImageCore, updateContactImageCore, uploadContactImageCore } from '@gv/core';

export type GalleryImage = {
    id: string;
    contact_id: string;
    url: string;
    source_type: 'manual' | 'event' | 'relationship' | 'todo';
    source_id?: string | null;
    tags: string[];
    created_at?: string;
};

export async function listContactImages(contactId: string): Promise<GalleryImage[]> {
    return (await listContactImagesCore(supabase as any, contactId)) as any as GalleryImage[];
}

export async function addContactImage(contactId: string, url: string, opts?: { source_type?: 'manual' | 'event' | 'relationship' | 'todo'; source_id?: string | null; tags?: string[]; }) {
    return (await addContactImageCore(supabase as any, contactId, url, opts)) as any as GalleryImage;
}

export async function deleteContactImage(id: string) {
    await deleteContactImageCore(supabase as any, id);
}

export async function updateContactImage(id: string, patch: Partial<Pick<GalleryImage, 'tags' | 'url'>>) {
    return (await updateContactImageCore(supabase as any, id, patch)) as any as GalleryImage;
}

export async function setDefaultProfileImage(contactId: string, url: string) {
    await setDefaultProfileImageCore(supabase as any, contactId, url);
}

export async function uploadContactImage(file: File, contactId: string): Promise<string> {
    return uploadContactImageCore(supabase as any, file, contactId);
}

// List images tied to a specific event for a contact
export async function listEventImages(contactId: string, eventId: string): Promise<GalleryImage[]> {
    const imgs = await listContactImagesCore(supabase as any, contactId);
    return (imgs || []).filter((i: any) => i.source_type === 'event' && i.source_id === eventId).sort((a: any, b: any) => String(b.created_at || '').localeCompare(String(a.created_at || '')) as any);
}
